
import './App.css';
import { router, } from "./Pages/index";
import { RouterProvider } from "react-router-dom";
import React, { useState, useEffect } from 'react'
import GlobalLoading from './Components/GlobalLoading/GlobalLoading';
import baseURL from './Components/url';

function App() {
  const [globalLoading, setGlobalLoading] = useState(true);

  useEffect(() => {
    const loadCriticalData = async () => {
      try {
        // Cargar todas las APIs críticas en paralelo
        const criticalAPIs = [
          fetch(`${baseURL}/userLogued.php`),
          fetch(`${baseURL}/productosGet.php`),
          fetch(`${baseURL}/categoriasGet.php`),
          fetch(`${baseURL}/bannersGet.php`),
          fetch(`${baseURL}/codigosGet.php`),
          fetch(`${baseURL}/contactoGet.php`)
        ];

        // Esperar a que todas las APIs críticas terminen
        await Promise.allSettled(criticalAPIs);
        
        // Pequeña pausa para mejor UX
        await new Promise(resolve => setTimeout(resolve, 500));
        
        setGlobalLoading(false);
      } catch (error) {
        console.error('Error en carga global:', error);
        // Si hay error, igual mostrar la aplicación
        setGlobalLoading(false);
      }
    };

    loadCriticalData();
  }, []);

  // Mostrar pantalla de carga global mientras carga
  if (globalLoading) {
    return <GlobalLoading />;
  }

  return (
    <RouterProvider router={router} />
  );
}

export default App;
